import type {
  ApiInternshipId,
  ApiJobId,
  ApiOrgId,
} from '#/api/types/ApiTypedId';
import { fetchRepostedListings } from '#/modules/orgDashboard/api/listing/orgDashboardApiListing';
import type { OrgHideRepostedListingsModalProps } from '#/modules/orgDashboard/modals/OrgHideRepostedListings/OrgHideRepostedListingsModalProps';

/**
 * Determines if the "Hide Reposted Listings" modal should be shown, and returns wether or not it will be.
 */
export async function maybeShowHideRepostedModal(
  orgId: ApiOrgId,
  showModal: (
    modalType: 'HIDE_REPOSTED_LISTINGS',
    modalProps: OrgHideRepostedListingsModalProps,
  ) => void,
  listingIds?: (ApiJobId | ApiInternshipId)[],
) {
  return fetchRepostedListings(orgId).then((listings) => {
    const repostedIds = listings.map((l) => l.id);

    if (
      (listingIds && repostedIds.some((id) => listingIds.includes(id))) ||
      repostedIds.length > 0
    ) {
      showModal('HIDE_REPOSTED_LISTINGS', { orgListings: listings, orgId });
      return true;
    }

    return false;
  });
}
